var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProtocolIcon(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 6H1V4h11V1.5L15.5 5 12 8.5zm-8 4h11v2H4v2.5L.5 11 4 7.5z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProtocolIcon);
export default __webpack_public_path__ + "static/media/protocol-icon.a90b71b07e85fa15550c28edec12cd91.svg";
export { ForwardRef as ReactComponent };